import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from "reactstrap";

const RejectionReasonModal = ({
  isOpen,
  toggle,
  reason,
  type,
  status
}) => {

  const documentName = type === "PO" 
    ? "Purchase Order" 
    : "Purchase Requisition";

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        ⚠ {documentName} {status}
      </ModalHeader>
      <ModalBody>
        <p>
          Your {documentName} has been {status}.
        </p>
        <strong>
          Reason:
        </strong>
        <p className="mt-2">
          {reason}
        </p>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={toggle}
        >
          Close
        </Button>

      </ModalFooter>

    </Modal>
  );
};

export default RejectionReasonModal;